import Seo from './Seo'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import useStyles from './styles'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

const breadcrumb = [
  { title: 'Wunschliste' },
]

const WunschlisteLehr = () => {
  const classes = useStyles()

  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <div className={classes.wunschlisteLehr}>

      <Typo component='h1' variant='h4' color='inherit' gutterBottom>
        Deine persönliche Wunschliste
      </Typo>

      <Typo component='p' variant='body1' color='inherit' gutterBottom>
        Du hast bis jetzt noch keine Artikel zu deiner Wunschliste hinzugefügt.
      </Typo>

    </div>
  </Container>

}

export default WunschlisteLehr
